<template>
    <div style="width:100%">
        <v-card v-if="registro.gesfraude">
            <v-toolbar :color="colores.primario" dark dense>
                <v-toolbar-title>FRAUDE</v-toolbar-title>
            </v-toolbar>
            <v-card-text>
              <v-row no-gutters>
                <v-col cols="12" md="6">
                  <texto3 :colores="colores" :titulo="'MODALIDAD'" :obj="registro.gesfraude.modalidad"></texto3>
                </v-col>
              </v-row>
              <v-row no-gutters>
                <v-col cols="12">
                  <texto3 :colores="colores" :titulo="'TIPO FRAUDE'" :obj="registro.gesfraude.tipofraude"></texto3>
                </v-col>
              </v-row>
              <v-row no-gutters>
                <v-col cols="12" md="6" class="pr-1">
                  <texto2 :colores="colores" :titulo="'MONTO RECLAMADO'" :descripcion="rec_function_numberWithCommas(registro.gesfraude.monto_reclamado, ',')"></texto2>
                </v-col>
                <v-col cols="12" md="6" class="pr-1">
                  <texto2 :colores="colores" :titulo="'MONTO RECONOCIDO'" :descripcion="rec_function_numberWithCommas(registro.gesfraude.modo_reconocido, ',')"></texto2>
                </v-col>
              </v-row>
              <br>
              <center><span class="text-h6">ARCHIVOS</span></center>
              <v-list dense>
              <div v-for="(archivo, i) in registro.gescierrefiles" :key="i">
                <div v-if="archivo.tipo === 2">
                    <verArchivos :colores="colores" :tipo="'CIERRE'" :item="archivo"></verArchivos>
                    <v-divider></v-divider>
                </div>
              </div>
          </v-list>
            </v-card-text>
        </v-card>
    </div>
</template>
<script>
import recFunciones from '@/js/rec_funciones.js'
import texto2 from '@/components/widgets/text2Component.vue'
import texto3 from '@/components/widgets/text3Component.vue'
import verArchivos from '@/components/widgets/ver_archivosComponent.vue'

export default {
  name: 'lectura_fraudeComponent',
  components: {
    texto2,
    texto3,
    verArchivos
  },
  mixins: [recFunciones],
  props: ['colores', 'registro'],
  data: () => ({
  }),
  created () {
  },
  methods: {
  }
}
</script>
